import React from 'react';
import { SVGProps } from '../../helpers/types';

const YellowRightTick: React.FC<SVGProps> = () => {
  return (
    <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.50004 9.50008L2.00004 6.00008L0.833374 7.16675L5.50004 11.8334L15.5 1.83341L14.3334 0.666748L5.50004 9.50008Z"
        fill="#FFE600"
      />
    </svg>
  );
};

export default YellowRightTick;
